import { useSelector } from "@xstate/store-react";
import { panelStore } from "@/app/providers/panel-store";

export const useSessionPanelOpen = () => useSelector(panelStore, (s) => s.context.activePanel === "session");

export const useSessionPanelActions = () => ({
  togglePanel: () => panelStore.send({ type: "panel.toggle", panel: "session" }),
  closePanel: () => panelStore.send({ type: "panel.close" }),
});
